import type { FunctionComponent } from "react";
import CampaignCard from "../../../components/campaign-card.components";
import type { ICampaign } from "../../../types/models/campaign.models.types";
import Spinner from "../../../components/spinner.components";
import type { IPagination } from "../../../types/models/pagination.models.types";
import type React from "react";
import PaginationComponent from "../../../components/pagination.components";

type AppProps = {
	fetching: boolean;
	campaignData: ICampaign[];
	setPageNo: React.Dispatch<React.SetStateAction<number>>;
	paginationData: IPagination;
	search?: string;
};

const DashboardCampaignsAdminPartial: FunctionComponent<AppProps> = ({
	fetching,
	campaignData,
	setPageNo,
	paginationData,
	search,
}) => {
	if (campaignData.length === 0 && fetching) {
		return (
			<div className="flex flex-col flex-1 justify-center items-center">
				<Spinner />
			</div>
		);
	}

	if (campaignData.length === 0) {
		return (
			<div className="flex flex-col flex-1 justify-center items-center">
				<p className="text-center text-secondary text-sm">No campaigns found</p>
			</div>
		);
	}

	return (
		<div>
			<div className="flex items-center">
				<div className="gap-6 grid grid-cols-3 w-full">
					{campaignData.map((campaign) => (
						<CampaignCard key={campaign.id} campaign={campaign} />
					))}
				</div>
			</div>
			{!search && (
				<PaginationComponent
					fetching={fetching}
					paginationData={paginationData}
					onClick={() => setPageNo((currentPage) => currentPage + 1)}
				/>
			)}
		</div>
	);
};

export default DashboardCampaignsAdminPartial;
